export const DEVICED_DEBUGBAR_TARGET_ID = '#portal-deviced-debugbar';
